export default {
    视频: '视频',
    产品: '产品',
    私人定制: '私人定制',
    签约艺术家: '签约艺术家',
    艺术家: '艺术家',
    新闻动态: '新闻动态',
    关于海伦: '关于海伦',
    联系我们: '联系我们',
    请输入搜索关键词: '请输入搜索关键词',
    文章: '文章',
    敲响中国爵士鼓制造业的新乐章: '敲响中国爵士鼓制造业的新乐章',
    产品搜索: '产品搜索',
    请选择: '请选择',
    请输入: '请输入',
    搜索: '搜索',
    留言给我们: '留言给我们',
    您的姓名: '您的姓名',
    您的电话: '您的电话',
    电话: '电话',
    留言内容: '留言内容',
    首页: '首页',
    数量: '数量',
    库存: '库存',
    音色视听: '音色视听',
    立即购买: '立即购买',
    加入购物车: '加入购物车',
    参数配置: '参数配置',
    评论: '评论',
    用户评论: '用户评论',
    '没有查询到评论信息...': '没有查询到评论信息...',
    商品不存在或已下架: '商品不存在或已下架',
    '商品配置有误，请检查商品配置！': '商品配置有误，请检查商品配置！',
    没有库存了: '没有库存了',
    请选择商品规格: '请选择商品规格',
    '该商品库存不足,无法购买': '该商品库存不足,无法购买',
    请输入艺术家姓名搜索: '请输入艺术家姓名搜索',
    '暂无内容...': '暂无内容...',
    关于艺术家: '关于艺术家',
    艺术家设备: '艺术家设备',
    企业新闻: '企业新闻',
    行业资讯: '行业资讯',
    '没有查询到相关信息...': '没有查询到相关信息...',
    上一篇: '上一篇',
    下一篇: '下一篇',
    没有了: '没有了',
    关于海伦: '关于海伦',
    公司简介: '公司简介',
    创始人介绍: '创始人介绍',
    企业荣誉: '企业荣誉',
    发展历程: '发展历程',
    生产线展示: '生产线展示',
    项: '项',
    爵士鼓生产线: '爵士鼓生产线',
    电鼓生产线: '电鼓生产线',
    欢迎关注海伦鼓尚在线平台: '欢迎关注海伦鼓尚在线平台',
    地址: '地址',
    邮箱: '邮箱',
    请输入您的姓名: '请输入您的姓名',
    请输入有效的手机号: '请输入有效的手机号',
    请输入留言内容: '请输入留言内容',
    '留言失败，请重试！': '留言失败，请重试！',
    个人中心: '个人中心',
    购物车: '购物车',
    '登录/注册': '登录/注册',
    返回: '返回',
    个人中心首页: '个人中心首页',
    订单管理: '订单管理',
    标准鼓订单: '标准鼓订单',
    定制鼓订单: '定制鼓订单',
    我的售后: '我的售后',
    收藏和足迹: '收藏和足迹',
    我的收藏: '我的收藏',
    浏览足迹: '浏览足迹',
    个人资料: '个人资料',
    地址管理: '地址管理',
    我的发票: '我的发票',
    个人信息: '个人信息',
    修改密码: '修改密码',
}
